import script from "./EthereumDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./EthereumDetails.vue?vue&type=script&setup=true&lang=js"

import "./EthereumDetails.vue?vue&type=style&index=0&id=37425b81&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37425b81"]])

export default __exports__